export const BJ_CONSOLE_LOG = 'console-log';
export const BJ_FETCH_RSS = 'fetch-rss';
export const BJ_FETCH_NEWS = 'fetch-news';
